import React, { useEffect, useState } from "react";
import { Row, Col, Button, Tag, Table, Modal, InputNumber, notification } from "antd";
import { EditOutlined, DeleteOutlined, ExclamationCircleOutlined, ArrowUpOutlined, ArrowDownOutlined, HddOutlined, CheckSquareTwoTone } from "@ant-design/icons";

import { FiltroProdutoNfi } from "../../components";
import { FormatNumber } from '../../ValueObjects';
import { useStateValue } from "../../state";
import api from "../../services/api";
import { ModalSelectLote } from "../../components/modals";

export default function TabItens({ form, dadosItens, dadosEndereco, dadosOperacao, dadosContribuinte, dadosVendedor, carregarPagina, notasSelecionadas, entregaFutura }) {

    const [{ manutencao }] = useStateValue();
    const [quantidadeItens, setQuantidadeItens] = useState(0);
    const [valorTotal, setValorTotal] = useState(0);
    const [editando, setEditando] = useState(false);
    const [abrirModalLote, setAbrirModalLote] = useState(false);
    const [dadosEditando, setDadosEditando] = useState({});
    const [dadosNotasAtualizados, setDadosNotasAtualizados] = useState([]);
    const [dadosLote, setDadosLote] = useState([]);
    const [dadosItem, setDadosItem] = useState([]);

    useEffect(() => {
        if (dadosOperacao.ope_tipolancamento === 2 && dadosItens.dadosItens.length > 0) {
            if (dadosItens.dadosItens.some((item) => item.prg_id)) {
                let itensSemGrade = dadosItens.dadosItens.filter((item) => !item.prg_id);
                notification.warning({ message: 'Aviso!', description: 'Produtos com grade não são permitidos quando operação de venda futura.' })
                dadosItens.setDadosItens(itensSemGrade);
            }
        }
    }, [])

    useEffect(() => {
        if (dadosItens.dadosItens.length > 0) {
            let total = 0;
            let totalSt = 0;
            setQuantidadeItens(dadosItens.dadosItens.length);
            dadosItens.dadosItens.forEach((item) => {
                total += parseFloat(item.total);
                totalSt += parseFloat(item.nfi_valoricmsst);
            });
            form.setFieldsValue({ valorTotalSt: totalSt });
            setValorTotal(total);
        } else {
            setQuantidadeItens(0);
            setValorTotal(0);
        }
    }, [dadosItens.dadosItens]);

    useEffect(() => {
        if (notasSelecionadas.notasSelecionadas.length > 0 && entregaFutura) {
            let total = 0;
            let dadosAtualizados = notasSelecionadas.notasSelecionadas.map((produto, index) => {
                const nfi_qtde = produto.nfi_qtde ?? 1;
                const nfi_valorunitario = produto.nfi_valorunitario ?? 0;

                return {
                    ...produto,
                    sequencia: index + 1,
                    nfi_qtde,
                    total: nfi_valorunitario * nfi_qtde
                };
            })
            dadosAtualizados.forEach((nota) => {
                total += parseFloat(nota.nfi_valorunitario) * nota.nfi_qtde;
            });
            setValorTotal(total);
            setQuantidadeItens(dadosAtualizados.length);
            setDadosNotasAtualizados(dadosAtualizados);
            notasSelecionadas.setNotasSelecionadas(dadosAtualizados);
        } else if (notasSelecionadas.notasSelecionadas.length === 0 && entregaFutura) {
            setQuantidadeItens(0);
            setValorTotal(0);
        }
    }, []);

    function mudarQuantidade(value, record) {
        let novosDados = dadosNotasAtualizados.map(item =>
            item.sequencia === record.sequencia ? { ...item, nfi_qtde: value, total: value * item.nfi_valorunitario } : item
        );

        setDadosNotasAtualizados(novosDados);
        notasSelecionadas.setNotasSelecionadas(novosDados);

        let novoTotal = novosDados.reduce((acc, item) => acc + item.total, 0);
        setValorTotal(novoTotal);
    }

    function perderFocoQuantidade(value, record) {
        if (value > record.saldo) {
            notification.warning({ message: 'Atenção!', description: 'Quantidade não pode ser maior que o saldo' });

            let novosDados = dadosNotasAtualizados.map(item =>
                item.sequencia === record.sequencia ? { ...item, nfi_qtde: record.saldo, total: record.saldo * item.nfi_valorunitario } : item
            );

            setDadosNotasAtualizados(novosDados);
            notasSelecionadas.setNotasSelecionadas(novosDados);

            let novoTotal = novosDados.reduce((acc, item) => acc + item.total, 0);
            setValorTotal(novoTotal);
        }
    }

    function editarItemNota(registro) {
        console.log("Clicou no Editar:", registro);
        setDadosEditando(registro);
        setEditando(true);
    };

    function removerItemNota(record, indice) {
        Modal.confirm({
            title: 'Aviso!',
            icon: <ExclamationCircleOutlined />,
            content: 'Deseja remover o item da nota?',
            okText: 'Sim',
            cancelText: 'Não',
            centered: true,
            onOk() {
                let dadosTemp = [...dadosItens.dadosItens];
                if (record.nfi_numeroitem) {
                    let dadosRet = dadosTemp.filter((item) => item.nfi_numeroitem !== record.nfi_numeroitem);
                    dadosItens.setDadosItens(dadosRet);
                } else if (record.pdi_numeroitem) {
                    let dadosRet = dadosTemp.filter((item) => item.pdi_numeroitem !== record.pdi_numeroitem);
                    dadosItens.setDadosItens(dadosRet);
                }
            }
        });
    };

    async function abriModalLote(record) {
        let listaLote = (await api.get(`ProdutoLote/ListarLotesSaldo?IdProduto=${record.pro_id}&ComSaldo=true`));
        if (listaLote.data.length > 0) {
            let seq = 0;
            listaLote.data.forEach((lote) => {
                lote.key = seq;
                seq++;
            });
            setDadosLote(listaLote.data);
            setDadosItem(record);
            setAbrirModalLote(true);
        } else {
            notification.warning({ message: 'Aviso', description: 'Nenhum lote encontrado para o produto selecionado!' });
            return false;
        }
    }

    function salvarLotes(itemCLote, listaTemp, dadosItemEditando) {
        setAbrirModalLote(false);
        if (itemCLote !== undefined && listaTemp !== undefined) {
            let dados = itemCLote;
            let listaItens = [...notasSelecionadas.notasSelecionadas];
            if (listaTemp.length > 0) {
                dados.nfitemlotes = listaTemp;
                let indice = listaItens.findIndex((item) => (item === dados));
                listaItens.splice(indice, 1, { ...dados });
                notasSelecionadas.setNotasSelecionadas(listaItens);
                notification.success({ message: 'Aviso', description: 'Lote do item adicionado com sucesso' });
            }
        }
    }

    return (
        <div className="m-t-16">
            {!entregaFutura && <FiltroProdutoNfi form={form} dadosTabela={dadosItens} dadosEndereco={dadosEndereco} dadosOperacao={dadosOperacao} dadosVendedor={dadosVendedor} btnEditando={{ editando, setEditando }} itemEditando={dadosEditando} carregarPagina={carregarPagina} />}
            <div className="tabela mt-dif">
                {!!dadosItens.dadosItens && dadosItens.dadosItens.length > 0 && !entregaFutura &&
                    <Table
                        columns={[
                            {
                                title: 'ITEM',
                                width: '30%',
                                fixed: 'left',
                                render: ({ pro_codigo, pro_descricao, nfi_ean, grade }) => (
                                    <div>
                                        <Row align="middle" gutter={[5, 0]}>
                                            <Col>
                                                <Tag color="processing" className="w-75">
                                                    <b>{pro_codigo}</b>
                                                </Tag>
                                                <b> {pro_descricao}</b>
                                            </Col>
                                        </Row>
                                        <Row align="middle" gutter={[5, 0]}>
                                            <Col>
                                                EAN: <b>{nfi_ean}</b>
                                            </Col>
                                            <Col hidden={!!!grade}>
                                                Grade: <b>{grade}</b>
                                            </Col>
                                        </Row>
                                    </div>
                                )
                            },
                            {
                                title: 'CFOP',
                                align: 'center',
                                width: '3%',
                                fixed: 'left',
                                render: ({ nfi_cfop }) => (
                                    <div>
                                        <b>{nfi_cfop}</b>
                                    </div>
                                ),
                            },
                            {
                                title: `${dadosContribuinte.emp_regimetributario === 1 ? 'CSOSN' : 'CST'}`,
                                align: 'center',
                                width: '4%',
                                fixed: 'left',
                                render: ({ cst_id, cso_id }) => (
                                    <div>
                                        <Col >
                                            <b>{dadosContribuinte.emp_regimetributario === 1 ? cso_id : cst_id}</b>
                                        </Col>
                                    </div>
                                ),
                            },
                            {
                                title: 'Qtde.',
                                width: '4%',
                                align: 'right',
                                fixed: 'left',
                                render: ({ nfi_qtde }) => (
                                    <div>
                                        <b>{FormatNumber(nfi_qtde, true)}</b>
                                    </div>
                                ),
                            },
                            {
                                title: 'Vlr Unt.(R$)',
                                align: 'right',
                                width: '5%',
                                fixed: 'left',
                                render: ({ nfi_valorunitario }) => (
                                    <div>
                                        <b>{FormatNumber(nfi_valorunitario, true)}</b>
                                    </div>
                                ),
                            },
                            {
                                title: 'Desc.',
                                align: 'right',
                                width: '4%',
                                render: ({ percdesc }) => (
                                    <div>
                                        <b>{percdesc}%</b>
                                    </div>
                                ),
                            },
                            {
                                title: 'Acres.',
                                align: 'right',
                                width: '4%',
                                render: ({ percacresc }) => (
                                    <div>
                                        <b>{percacresc}%</b>
                                    </div>
                                ),
                            },
                            {
                                title: 'Vlr. Frete',
                                align: 'right',
                                width: '4%',
                                render: ({ nfi_valorfrete }) => (
                                    <div>
                                        <b>{FormatNumber(nfi_valorfrete, true)}</b>
                                    </div>
                                ),
                            },
                            {
                                title: 'Bc. Icms',
                                align: 'right',
                                width: '4%',
                                render: ({ impostos }) => (
                                    <div>
                                        <b>{FormatNumber(impostos?.retornoICMS?.ret_baseIcms, true)}</b>
                                    </div>
                                ),
                            },
                            {
                                title: '% Icms',
                                align: 'right',
                                width: '4%',
                                render: ({ impostos }) => (
                                    <div>
                                        <b>{FormatNumber(impostos?.retornoICMS?.ret_aliquotaIcms, true)}</b>
                                    </div>
                                ),
                            },
                            {
                                title: 'Vlr Icms',
                                align: 'right',
                                width: '4%',
                                render: ({ impostos }) => (
                                    <div>
                                        <b>{FormatNumber(impostos?.retornoICMS?.ret_valorIcms, true)}</b>
                                    </div>
                                ),
                            },
                            {
                                title: 'Bc. ST',
                                align: 'right',
                                width: '4%',
                                render: ({ impostos }) => (
                                    <div>
                                        <b>{FormatNumber(impostos?.retornoICMSST?.ret_baseIcmsSt, true)}</b>
                                    </div>
                                ),
                            },
                            {
                                title: '% ST',
                                align: 'right',
                                width: '4%',
                                render: ({ impostos }) => (
                                    <div>
                                        <b>{FormatNumber(impostos?.retornoICMSST?.ret_aliquotaIcmsSt, true)}</b>
                                    </div>
                                ),
                            },
                            {
                                title: 'Vlr ST',
                                align: 'right',
                                width: '4%',
                                render: ({ impostos }) => (
                                    <div>
                                        <b>{FormatNumber(impostos?.retornoICMSST?.ret_valorIcmsSt, true)}</b>
                                    </div>
                                ),
                            },
                            {
                                title: 'Vlr Total (R$)',
                                align: 'right',
                                width: '6%',
                                fixed: 'right',
                                render: ({ total }) => (
                                    <div>
                                        <b>{FormatNumber(total, true)}</b>
                                    </div>
                                ),
                            },
                            {
                                title: 'Ações',
                                dataIndex: '',
                                key: 'x',
                                align: 'center',
                                width: '5%',
                                fixed: 'right',
                                render: (record, e, indice) => (
                                    <div>
                                        <Row align="center" justify="center" gutter={[5, 0]}>
                                            <Col>
                                                <Button icon={<EditOutlined />} onClick={() => editarItemNota(record)} disabled={manutencao.dados?.ntf_id} />
                                            </Col>
                                            <Col>
                                                <Button icon={<DeleteOutlined />} onClick={() => removerItemNota(record, indice)} disabled={manutencao.dados?.ntf_id} />
                                            </Col>
                                        </Row>
                                    </div>
                                ),
                            },
                        ]} dataSource={dadosItens.dadosItens}
                        scroll={{
                            x: 1500,
                            y: 300,
                        }} />}
                {!!dadosNotasAtualizados && dadosNotasAtualizados.length > 0 && entregaFutura &&
                    <Table
                        columns={[
                            {
                                title: 'N°',
                                width: '5%',
                                fixed: 'left',
                                align: 'center',
                                render: ({ sequencia }) => (
                                    <div>
                                        <Tag color="processing" className="w-75">
                                            <b>{sequencia}</b>
                                        </Tag>
                                    </div>
                                )
                            },
                            {
                                title: 'Código',
                                width: '5%',
                                fixed: 'left',
                                align: 'center',
                                render: ({ pro_codigo }) => (
                                    <b>{pro_codigo}</b>
                                )
                            },
                            {
                                title: 'Descrição',
                                width: '50%',
                                fixed: 'left',
                                render: ({ pro_descricao }) => (
                                    <div>
                                        <b> {pro_descricao}</b>
                                    </div>
                                )
                            },
                            {
                                title: 'Qtde.',
                                width: '10%',
                                align: 'right',
                                fixed: 'left',
                                render: (record) => (
                                    <Row align="middle">
                                        <InputNumber
                                            min={1}
                                            value={record.nfi_qtde}
                                            onChange={(value) => mudarQuantidade(value, record)}
                                            onBlur={(e) => perderFocoQuantidade(e.target.value, record)}
                                        />
                                    </Row>
                                ),
                            },
                            {
                                title: 'Vlr Unt.(R$)',
                                align: 'right',
                                width: '10%',
                                fixed: 'left',
                                render: ({ nfi_valorunitario }) => (
                                    <div>
                                        <b>{FormatNumber(nfi_valorunitario, true)}</b>
                                    </div>
                                ),
                            },
                            {
                                title: 'Vlr Total (R$)',
                                align: 'right',
                                width: '10%',
                                fixed: 'right',
                                render: ({ total }) => (
                                    <div>
                                        <b>{FormatNumber(total, true)}</b>
                                    </div>
                                ),
                            },
                            {
                                title: 'Saldo',
                                align: 'center',
                                width: '10%',
                                fixed: 'right',
                                render: ({ saldo }) => (
                                    <div>
                                        <b className='f-16'>{saldo}</b>
                                    </div>
                                ),
                            },
                            {
                                title: 'Lotes',
                                dataIndex: '',
                                key: 'x',
                                align: 'center',
                                fixed: 'right',
                                render: (record, e, indice) => {
                                    const temControleLote = record.pro_controlelote;
                                    const lotesInformados = record.nfitemlotes;
                                    const quantidadeLote = lotesInformados?.reduce((soma, lote) => soma + (lote.nfl_qtde || 0), 0);
                                    const quantidadeIgual = quantidadeLote === record.nfi_qtde;

                                    let icone = <HddOutlined />;

                                    if (temControleLote) {
                                        if (lotesInformados && lotesInformados.length > 0 && quantidadeIgual) {
                                            icone = <CheckSquareTwoTone twoToneColor="#52c41a" />;
                                        }
                                    }

                                    return (
                                        <div>
                                            <Row align="center" justify="center" gutter={[5, 0]}>
                                                <Col>
                                                    <Button
                                                        icon={icone} onClick={() => abriModalLote(record)} disabled={manutencao.dados?.ntf_id || !temControleLote}
                                                    />
                                                </Col>
                                            </Row>
                                        </div>
                                    );
                                },
                            },
                        ]} dataSource={dadosNotasAtualizados} rowKey="sequencia"
                    />
                }
            </div>
            <div>
                <Row justify="end" gutter={[8, 0]}>
                    <Col className="f-16 m-t-3">
                        <b>Quantidade Itens:</b>
                    </Col>
                    <Col className="f-21">
                        <b>{quantidadeItens}</b>
                    </Col>
                </Row>
                <Row justify="end" gutter={[8, 0]}>
                    <Col className="f-16 m-t-3">
                        <b>Valor Total dos Itens (R$):</b>
                    </Col>
                    <Col className="f-21">
                        <b>{FormatNumber(valorTotal, true)}</b>
                    </Col>
                </Row>
            </div >
            <ModalSelectLote exibirModal={abrirModalLote} fecharModal={(itemCLote, listaTemp, dadosItemEditando) => salvarLotes(itemCLote, listaTemp, dadosItemEditando)} dadosLote={dadosLote} setDadosLote={setDadosLote} formulario={form} dadosItem={dadosItem} />
        </div>
    );
}